var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.report.calls, function(call) {
      return _c(
        "div",
        {
          key: call.opened,
          staticClass: "card call-card",
          class: {
            answered: call.answered,
            voicemail: call.voicemail_left,
            noring: call.attempts === 0
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "card-heading call-heading d-flex",
              attrs: { "data-toggle": "collapse", href: "#id-" + call.opened }
            },
            [
              _c("span", { staticClass: "card-title call-title" }, [
                _vm._v(
                  "\n        Call from " + _vm._s(call.from) + "\n        "
                ),
                call.answered
                  ? _c("span", [_vm._v("successfully answered")])
                  : call.voicemail_left
                  ? _c("span", [_vm._v("left a voicemail")])
                  : call.attempts === 0
                  ? _c("span", [_vm._v("failed to call base2")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "ml-auto" }, [
                _vm._v(
                  "(" +
                    _vm._s(_vm._f("moment")(call.opened, "MMM Do, h:mm a")) +
                    ")"
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card-collapse collapse",
              attrs: { id: "id-" + call.opened }
            },
            [
              _c("ul", [
                _c("li", { staticClass: "call-collapse" }, [
                  _vm._v("Call made to the " + _vm._s(call.region) + " region")
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "call-collapse" }, [
                  _vm._v(
                    "OpsGenie attempted to call " +
                      _vm._s(call.attempts) +
                      " times"
                  )
                ]),
                _vm._v(" "),
                call.answered
                  ? _c("li", { staticClass: "call-collapse" }, [
                      _vm._v(
                        "Answered in " + _vm._s(call.answered) + " seconds"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                call.completed
                  ? _c("li", { staticClass: "call-collapse" }, [
                      _vm._v(
                        "Call completed in " +
                          _vm._s(call.completed) +
                          " seconds"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                call.voicemail_left
                  ? _c("li", { staticClass: "call-collapse" }, [
                      _c("a", { attrs: { href: call.voicemail_link } }, [
                        _vm._v("Listen to voicemail")
                      ])
                    ])
                  : _vm._e()
              ])
            ]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b61bd246", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b61bd246","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CallLogs.vue
// module id = null
// module chunks = 